import React from "react";
import Logo from "../Logo";

export const Footer = () => {
  return (
    <footer className="px-5 md:px-10 pb-24 pt-10" data-testid="site-footer">
      <div className="max-w-6xl mx-auto crayon-card-soft px-6 py-8 rotate-[-0.5deg]">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <Logo size={70} withSpinner />
            <div>
              <div className="font-display text-3xl text-[#E8742C]">$RETARD</div>
              <div className="text-sm text-[#1A1A1A]/70">on solana ✦ probably ✦ launch day TBD</div>
            </div>
          </div>
          <p className="text-sm md:text-base text-center md:text-right max-w-md text-[#1A1A1A]/80">
            ⚠ $RETARD is a memecoin with zero utility, zero promises, and a
            propeller hat. nothing on this page is financial advice. don't risk
            your lunch money, retard.
          </p>
        </div>
        <div className="mt-6 border-t-4 border-dashed border-[#1A1A1A]/30 pt-4 text-center font-display text-xl text-[#1A1A1A]/70">
          made with crayons & love ✦ © {new Date().getFullYear()} retard inc. (not a real inc.)
        </div>
      </div>
    </footer>
  );
};

export default Footer;
